export const webinarSingleUseAllowed = window.newBillingConfig?.webinarSingleUseAllowed || false;
export const enableNewUIWebinarOneTimePlan = window.newBillingConfig?.enableNewUIWebinarOneTimePlan || false;

export const enableNewUIForZS = window.newBillingConfig?.enableNewUIForZS || false;
